import type { Participant } from '@seen/core/models/patients/participant'
import { IconId } from '@tabler/icons-react'
import type { JSX } from 'react'
import { CopyButton } from '#src/components/core/CopyButton.tsx'
import { TextLink } from '#src/components/core/TextLink.tsx'
import {
  FacesheetCard,
  FacesheetCardCollapseTrigger,
  FacesheetCardContent,
  FacesheetCardHeader,
  FacesheetCardIcon,
  FacesheetCardLabel,
  FacesheetCardTitle,
} from '#src/components/patient/detail-content/facesheet/index.ts'

export interface InsuranceCardProps {
  participant: Participant
}

export function InsuranceCard({
  participant,
}: InsuranceCardProps): JSX.Element {
  return (
    <FacesheetCard rumName="insurance">
      <FacesheetCardHeader>
        <FacesheetCardTitle>
          <FacesheetCardIcon>
            <IconId />
          </FacesheetCardIcon>
          <FacesheetCardLabel>
            <TextLink to={`${participant.relativeUrl}/coverage`}>
              Insurance
            </TextLink>
          </FacesheetCardLabel>
          <FacesheetCardCollapseTrigger />
        </FacesheetCardTitle>
      </FacesheetCardHeader>
      <FacesheetCardContent>
        <div className="grid grid-cols-2 gap-x-4 gap-y-3">
          <InsuranceField
            label="Medicaid ID"
            value={participant.medicaidId}
            copyable
          />
          <InsuranceField
            label="Medicare ID"
            value={participant.medicareId}
            copyable
          />
        </div>
      </FacesheetCardContent>
    </FacesheetCard>
  )
}

function InsuranceField({
  label,
  value,
  copyable = false,
}: {
  label: string
  value: string | undefined
  copyable?: boolean
}): JSX.Element {
  return (
    <div className="flex flex-col gap-0.5">
      <p className="text-xs font-semibold text-foreground-secondary">{label}</p>
      {value ? (
        <div className="flex items-center gap-1">
          <p className="text-xs text-foreground-secondary">{value}</p>
          {copyable && (
            <CopyButton
              value={value}
              ariaLabel={`Copy ${label}`}
              className="size-5"
            />
          )}
        </div>
      ) : (
        <p className="text-xs text-foreground-tertiary">Not on file</p>
      )}
    </div>
  )
}
